import React from "react";
import clsx from "clsx";

interface TableColumnProps {
    children: React.ReactNode | React.ReactNode[];
    className?: string;
    colSpan?: number;
}

const TableColumn = (props: TableColumnProps) => {
    return (
        <td className={clsx("TableColumn py-2 px-1.5 first:!pl-3 last:!pr-3", props.className)} colSpan={props?.colSpan}>
            {props.children}
        </td>
    );
};

export default TableColumn;